import React, { useState, useMemo } from "react";
import { ArrowUpRight } from "lucide-react";
import { PageHero, SectionLabel, Reveal } from "../components/common";
import { CtaBand } from "./Home";
import { IMG, MACHINES, CATEGORIES } from "../mock";

export default function Machines() {
  const [active, setActive] = useState("All");
  const list = useMemo(
    () => (active === "All" ? MACHINES : MACHINES.filter((m) => m.category === active)),
    [active]
  );

  return (
    <main>
      <PageHero
        index="09"
        eyebrow="A Garry Industries Ventures · Machine Ecosystem"
        title="A complete family of railway machines."
        subtitle="From heavy track machinery to autonomous inspection robots — each concept is engineered to be feasible, serviceable and intelligent. Explore the ecosystem."
        image={IMG.trolley}
      />

      <section className="relative bg-[#0a0a0a] py-16 md:py-24">
        <div className="dot-grid absolute inset-0 opacity-20 pointer-events-none" />
        <div className="relative mx-auto max-w-[1400px] px-5 md:px-10">
          {/* Filters */}
          <div className="flex flex-wrap gap-2">
            {CATEGORIES.map((c) => (
              <button
                key={c}
                onClick={() => setActive(c)}
                className={`btn-accent eyebrow px-4 py-2.5 border transition-colors ${
                  active === c
                    ? "bg-[#c3e63c] text-[#0a0a0a] border-[#c3e63c]"
                    : "border-white/15 text-neutral-400 hover:text-white hover:border-white/40"
                }`}
              >
                {c}
              </button>
            ))}
          </div>

          {/* Grid */}
          <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((m, i) => (
              <Reveal key={m.id} delay={(i % 3) * 70} className="group relative overflow-hidden border border-white/10 bg-[#0d0d0d] card-hover hover:border-[#c3e63c]/40">
                <div className="relative h-56 overflow-hidden">
                  <img src={m.image} alt={m.name} className="img-zoom h-full w-full object-cover" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0d0d0d] via-transparent to-transparent" />
                  <div className="absolute top-4 left-4 eyebrow bg-[#0a0a0a]/80 px-2.5 py-1 text-[#c3e63c] backdrop-blur">{m.category}</div>
                </div>
                <div className="p-6">
                  <h3 className="font-display text-xl font-semibold">{m.name}</h3>
                  <p className="mt-2 text-sm text-neutral-400">{m.tagline}</p>
                  <div className="mt-5 flex items-center gap-2 eyebrow text-neutral-500 group-hover:text-[#c3e63c] transition-colors">
                    View specifications <ArrowUpRight size={14} />
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          {list.length === 0 && (
            <p className="mt-16 text-center text-neutral-500">No machines in this category yet.</p>
          )}
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
